<template>
  <VanPopup :show="show" round @update:show="emit('update:show', $event)">
    <div
      class="flex flex-col items-center justify-center pt-16 pb-4 px-12 text-center"
    >
      <logo-icon class="w-[153px] text-primary" />
      <div class="rounded overflow-hidden">
        <img
          alt=""
          class="w-[303px] mt-8"
          src="https://anymate-us.oss-us-west-1.aliyuncs.com/drawing/202406/18/8c72ed1f-7e50-4820-b033-74f34c614215.jpg"
        />
      </div>
      <div class="text-left w-full">
        <div class="text-center">
          <h2 class="mt-8 mb-1.5 text-xl font-semibold">
            {{ t(`nsfw.age.welcome`) }}
          </h2>
        </div>
        <p class="text-base font-normal">{{ t(`nsfw.age.rules`) }}</p>
        <ul class="list-disc pl-4 mb-5">
          <li>{{ t(`nsfw.age.rules1`) }}</li>
          <li>{{ t(`nsfw.age.rules2`) }}</li>
          <li>{{ t(`nsfw.age.rules3`) }}</li>
        </ul>

        <VanCheckbox v-model="checked">
          {{ t(`nsfw.age.oldThan18`) }}
        </VanCheckbox>
      </div>

      <div class="flex flex-col mt-8 gap-4">
        <button class="btn btn-primary" @click="clickEnter">
          {{ btnTxt ? btnTxt : t(`nsfw.age.enterAnymate`) }}
        </button>
      </div>
    </div>
  </VanPopup>
</template>
<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { showLoadingToast } from "vant";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const userStore = useGlobalUser();

defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  btnTxt: {
    type: String,
    default: "",
  },
});

const emit = defineEmits({
  "update:show": (val: boolean) => undefined,
  enter: () => undefined,
});
const { t } = useI18n();
const checked = ref(false);

const clickEnter = async () => {
  const loading = showLoadingToast({
    duration: 0,
    message: t("Message.updating"),
  });
  try {
    await userStore.confirmAge(checked.value);
  } finally {
    loading.close();
  }
  emit("update:show", false);
  emit("enter");
};
</script>
